import EvaluacionDesempenio from './EvaluacionDesempenio'

const DEFAULT_EVALUACION_STATUS = 1

export default class EvaluacionDisciplinaOperativa extends EvaluacionDesempenio {
  idEstatus
  procedimientos

  constructor(idEvaluado) {
    super(idEvaluado)
    this.idEstatus = DEFAULT_EVALUACION_STATUS
    this.procedimientos = []
  }
}
